import { theme } from '@nicejob-library/design-system';
import {
    AuthCard,
    AuthCardText,
    AuthContainer,
    AuthContent,
    AuthFooter,
} from '@nicejob-library/design-system/authentication';
import { translate } from '@nicejob-library/internationalization';
import React, { ReactElement } from 'react';
import { ThemeProvider } from 'styled-components';
import { IResetPasswordInvalidPageProps } from '../../../types/login.types';
import { ForgotPasswordLink } from '../components/common/ForgotPasswordLink';
import { HeaderLogo } from '../components/common/HeaderLogo';
import { LoginLink } from '../components/common/LoginLink';

export function ResetPasswordInvalidPage(props: IResetPasswordInvalidPageProps): ReactElement {
    const { branding, language } = props;

    return (
        <ThemeProvider theme={theme}>
            <AuthContainer>
                <HeaderLogo branding={branding} />

                <AuthContent>
                    <AuthCard>
                        <AuthCardText>
                            {translate({
                                namespace: 'login',
                                key: 'reset_password.invalid',
                                language,
                            })}
                        </AuthCardText>
                    </AuthCard>
                </AuthContent>

                <AuthFooter>
                    <LoginLink branding={branding} language={language} />
                    <ForgotPasswordLink />
                </AuthFooter>
            </AuthContainer>
        </ThemeProvider>
    );
}
